<template>
    <div class="product"></div>
</template>

<script>
export default {
    name: "CatalogSkeleton"
}
</script>

<style lang="scss" scoped>

.product:empty {
    margin: 0 0 25px;
    width: 100%;
    height: 200px; /* change height to see repeat-y behavior */

    background-image:
        linear-gradient(to right, lightgray 99%, transparent 0 ),
        linear-gradient( 100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80% ),
        linear-gradient( lightgray 20px, transparent 0 ),
        linear-gradient( lightgray 20px, transparent 0 ),
        linear-gradient( lightgray 20px, transparent 0 ),
        linear-gradient( lightgray 20px, transparent 0 );

    background-repeat: no-repeat;

    background-size:
        200px 200px, /* circle */
        50px 200px, /* highlight */
        150px 200px,
        350px 200px,
        300px 200px,
        250px 200px;

    background-position:
        0 0, /* circle */
        0 0, /* highlight */
        220px 20px,
        220px 60px,
        220px 100px,
        220px 140px;

    animation: shine 1.5s infinite;


    @keyframes shine {
        to {
            background-position:
                0 0,
                100% 0, /* move highlight to right */
                220px 20px,
                220px 60px,
                220px 100px,
                220px 140px;
        }
    }

    @media screen and (max-width: 1200px) {
        height: 500px;

        background-size:
            110% 250px,
            50px 200px,
            45% 200px,
            80% 200px,
            70% 200px,
            60% 200px;


        background-position:
            0 0, /* circle */
            0 270px, /* highlight */
            20px 270px,
            20px 310px,
            20px 350px,
            20px 390px;

        @keyframes shine {
            to {
                background-position:
                    0 0,
                    100% 270px, /* move highlight to right */
                    20px 270px,
                    20px 310px,
                    20px 350px,
                    20px 390px;
            }
        }


    }



}


</style>
